import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }
        
    to {
        transform: rotate(360deg);
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    align-items: center;
    justify-content: center;
    background: #f4f4f4;
`;

export const Loading = styled.div`
    color: ${props => props.theme.colours.textGreen};
    margin-bottom: 10px;
    margin-top: 0;
    display: inline-block;
    width: 54px;
    height: 54px;
    border: 2px solid;
    border-color: transparent currentColor currentColor;
    vertical-align: middle;
    overflow: hidden;
    text-indent: 100%;
    border-radius: 100%;
    -webkit-animation: ${rotate} 0.8s linear infinite;
    opacity: 1;
    visibility: visible;
    transition: opacity 2s ease, visibility 2s ease;
`;

export const LoadingIcon = styled.div`
    color: #fff;
    display: inline-block;
    margin-bottom: 10px;
    width: 1em;
    height: 1em;
    font-size: 50px;
    border: 2px solid;
    border-color: transparent currentColor currentColor;
    vertical-align: middle;
    overflow: hidden;
    text-indent: 100%;
    border-radius: 100%;
    -webkit-animation: ${rotate} 0.8s linear infinite;
    opacity: 1;
    visibility: visible;
    transition: opacity 2s ease, visibility 2s ease;
`;

export const Heading = styled.h1`
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.xlarge};
    color: ${props => props.theme.colours.textGreen};
`;
